/* eslint-disable react/no-array-index-key */

import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * ListFilters
 *
 */
import React from 'react'

// import { FormattedMessage } from 'react-intl';
import filterData from './fixtures/fixture.json'

// import messages from './messages';

const styles = theme => ({
  root: {
    display: 'inline-block',
    flexWrap: 'wrap',
    width: '100%',
    float: 'left',
  },
  formControl: {
    border: '1px solid #ccc',
    width: '100%',
    borderRadius: '5px',
    backgroundColor: theme.colors.white,
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div>div': {
      width: '92%',
      padding: '10px',
      fontSize: '14px',
    },
  },
})

/* eslint-disable react/prefer-stateless-function */
class DropDownFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filterData: this.props.filterData,
      selected: this.props.selected,
    }
  }

  handleChange = event => {
    const value = event.target.value.split('#')
    // eslint-disable-next-line react/no-access-state-in-setstate
    const selected = { ...this.state.selected }
    selected[value[0]] = {
      _id: value[1],
      value: event.target.value,
    }
    this.setState({ selected })
    const selectedOption = { ...this.state.selected }
    selectedOption[value[0]] = {
      _id: value[1] === 0 ? '' : value[1],
      value: event.target.value,
    }
    this.props.onChange(selectedOption)
  }

  render() {
    const { classes } = this.props
    // eslint-disable-next-line no-shadow
    const { filterData, selected } = this.state

    return (
      <div autoComplete="off" className={classes.root}>
        {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
        {filterData &&
          filterData.map((item, key) => (
            <FormControl
              key={`item${
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                key
              }`}
              className={classes.formControl}
            >
              <Select
                value={
                  // biome-ignore lint/complexity/useOptionalChain: TODO
                  selected && selected[item.key] && selected[item.key].value
                    ? selected[item.key].value
                    : `${item.key}#0`
                }
                onChange={this.handleChange}
                displayEmpty
                name={item.key}
                className={classes.stgSelect}
              >
                <MenuItem value={`${item.key}#0`}>All {item.key}</MenuItem>
                {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
                {item.value &&
                  item.value.map(option => (
                    <MenuItem
                      key={`itemIn${
                        // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                        key
                      }`}
                      value={`${item.key}#${option[`${item.key_prefix}id`]}`}
                    >
                      {option[`${item.key_prefix}name`]}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          ))}
      </div>
    )
  }
}

DropDownFilter.defaultProps = {
  onChange: () => {},
  filterData,
  selected: [],
}
export default withStyles(styles)(DropDownFilter)
